module.exports = __webpack_public_path__ + "static/media/pickle-rick.fb50a355.gif";